import React, { useEffect, useState } from "react";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import sessionExpiredError from "../../Errors/sessionExpiredError";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import { setDynamicCookieForUser } from "../../../Util/API Calls/cookieHelper";
import { useCookies } from "react-cookie";
const DoctorContext = React.createContext();

export const DoctorContextProvider = ({ children }) => {
  const [doctorList, setDoctorList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState([]);
  const [clinic_id, setClinicId] = useState();
  const [doctorRole, setDoctorRole] = useState();
  const [enableLeadsDashboard, setEnableLeadsDashboard] = useState("");
  const [cookies, setCookie] = useCookies(["cookie-name"]);
  let userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  let staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  useEffect(() => {
    if (
      clinicId !== null &&
      clinicId !== undefined &&
      ((localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) &&
        localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) !== "consultant") ||
        (userType === "staff" && staffClinicAssociation === "true"))
    ) {
      getDoctorList(clinicId);
      setClinicId(clinicId);
      setDoctorRole(localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE));
    } else {
      setDoctorRole(localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE));
      setClinicId(clinicId);
    }
  }, [clinicId]);

  useEffect(() => {
    if (
      userType == "staff" &&
      (clinicId == undefined || clinicId == null || clinicId == "")
    )
      getDoctorListForMyClinic();
  }, []);

  const getDoctorList = (clinicId) => {
    if (clinicId == null) return;
    afterLoginApiAxios
      .get("clinic/get-clinic-doctors", {
        headers: {
          Authorization: localStorage.getItem("id_token"),
        },
        params: {
          clinic_id: clinicId,
        },
      })
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          let result = [];
          let doctorSelected = JSON.parse(
            localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
          );
          // console.log(" ----> 1", doctorSelected);
          if (
            doctorSelected?.length > 0 &&
            doctorSelected !== null &&
            (clinicId !== null || clinicId !== undefined)
          ) {
            var foundDoctorIndex = doctorSelected?.findIndex(
              (doctor) => doctor?.clinic_id === clinicId
            );
            if (foundDoctorIndex > -1) {
              result = res?.data?.doctor_list?.map((doctor) => {
                let selectedDoctors = doctorSelected[
                  foundDoctorIndex
                ]?.doctors?.some(
                  (selectedDoctor) =>
                    doctor?.doctor_id === selectedDoctor?.doctor_id
                );
                if (selectedDoctors) {
                  return {
                    ...doctor,
                    selected: true,
                    selected_doctor: false,
                    id: doctor?.doctor_id,
                    label: doctor?.doctor_name,
                    value: doctor?.doctor_first_name,
                    name: doctor?.doctor_name,
                    initials: doctor?.doctor_first_name?.charAt(0),
                  };
                } else {
                  return {
                    ...doctor,
                    selected: false,
                    selected_doctor: false,
                    id: doctor?.doctor_id,
                    label: doctor?.doctor_name,
                    value: doctor?.doctor_first_name,
                    name: doctor?.doctor_name,
                    initials: doctor?.doctor_first_name?.charAt(0),
                  };
                }
              });
              setDoctorList(result);
            } else {
              let selectedDoctorArr = [];
              doctorSelected = doctorSelected || [];
              selectedDoctorArr = res?.data?.doctor_list?.map((doctor) => {
                return {
                  ...doctor,
                  selected: true,
                  selected_doctor: false,
                  id: doctor?.doctor_id,
                  label: doctor?.doctor_name,
                  value: doctor?.doctor_name,
                  name: doctor?.doctor_name,
                  initials: doctor?.doctor_name?.charAt(0),
                };
              });
              doctorSelected.push({
                clinic_id: clinicId,
                doctors: selectedDoctorArr,
              });
              // console.log("----> 2", doctorSelected);
              localStorage.setItem(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected)
              );
              setDynamicCookieForUser(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected),
                setCookie
              );
              setDoctorList(selectedDoctorArr);
            }
          } else {
            let selectedDoctorArr = [];
            doctorSelected = doctorSelected || [];
            selectedDoctorArr = res?.data?.doctor_list?.map((doctor) => {
              return {
                ...doctor,
                selected: true,
                selected_doctor: false,
                id: doctor?.doctor_id,
                label: doctor?.doctor_name,
                value: doctor?.doctor_name,
                name: doctor?.doctor_name,
                initials: doctor?.doctor_name?.charAt(0),
              };
            });
            doctorSelected.push({
              clinic_id: clinicId,
              doctors: selectedDoctorArr,
            });
            // console.log(" ----> 3", doctorSelected);
            localStorage.setItem(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected)
            );
            setDynamicCookieForUser(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected),
              setCookie
            );
            setDoctorList(selectedDoctorArr);
          }
        } else {
          setDoctorList([]);
        }
      })
      .catch((error) => {
        setDoctorList([]);
        if (error?.response?.status === 403) {
          sessionExpiredError(() => {
            localStorage.clear();
            this.props.history.push("/doctor/login");
          });
        }
        C2CConsole.log(error);
      });
  };

  const getDoctorListForMyClinic = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/staff/get-complete-staff-info",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: 4,
          staff_id: staffId,
        },
        staff_id: staffId,
        search: "False",
        dr_name: "",
        dr_phone_no: "",
      },
    })
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          let result = [];
          let doctorSelected = JSON.parse(
            localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
          );

          if (
            doctorSelected?.length > 0 &&
            doctorSelected !== null &&
            (clinicId !== null || clinicId !== undefined)
          ) {
            var foundDoctorIndex = doctorSelected?.findIndex(
              (doctor) => doctor?.clinic_id === clinicId
            );
            if (foundDoctorIndex > -1) {
              result = res?.data?.all_related_doctors?.map((doctor) => {
                let selectedDoctors = doctorSelected[
                  foundDoctorIndex
                ]?.doctors?.some(
                  (selectedDoctor) =>
                    doctor?.doctor_id === selectedDoctor?.doctor_id
                );
                if (selectedDoctors) {
                  return {
                    ...doctor,
                    selected: true,
                    selected_doctor: false,
                    doctor_first_name: doctor?.dr_first_name,
                    doctor_last_name:
                      doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                    doctor_profile_picture_url: doctor?.profile_picture_url
                      ? [doctor?.profile_picture_url]
                      : [],
                    id: doctor?.doctor_id,
                    label: doctor?.dr_name,
                    value: doctor?.dr_first_name,
                    name: doctor?.dr_name,
                    initials: doctor?.dr_first_name?.charAt(0),
                    doctor_phone_no: doctor?.dr_phone_no,
                    doctor_name: doctor?.dr_name,
                  };
                } else {
                  return {
                    ...doctor,
                    selected: false,
                    selected_doctor: false,
                    doctor_first_name: doctor?.dr_first_name,
                    doctor_last_name:
                      doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                    doctor_profile_picture_url: doctor?.profile_picture_url
                      ? [doctor?.profile_picture_url]
                      : [],
                    id: doctor?.doctor_id,
                    label: doctor?.dr_name,
                    value: doctor?.dr_first_name,
                    name: doctor?.dr_name,
                    initials: doctor?.dr_first_name?.charAt(0),
                    doctor_phone_no: doctor?.dr_phone_no,
                    doctor_name: doctor?.dr_name,
                  };
                }
              });
              setDoctorList(result);
            } else {
              let selectedDoctorArr = [];
              doctorSelected = doctorSelected || [];
              selectedDoctorArr = res?.data?.all_related_doctors?.map(
                (doctor) => {
                  return {
                    ...doctor,
                    selected: true,
                    selected_doctor: false,
                    doctor_first_name: doctor?.dr_first_name,
                    doctor_last_name:
                      doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                    doctor_profile_picture_url: doctor?.profile_picture_url
                      ? [doctor?.profile_picture_url]
                      : [],
                    id: doctor?.doctor_id,
                    label: doctor?.dr_name,
                    value: doctor?.dr_first_name,
                    name: doctor?.dr_name,
                    doctor_name: doctor?.dr_name,
                    initials: doctor?.dr_first_name?.charAt(0),
                    doctor_phone_no: doctor?.dr_phone_no,
                  };
                }
              );
              doctorSelected.push({
                clinic_id: clinicId,
                doctors: selectedDoctorArr,
              });
              // console.log(" ----> 5", doctorSelected);
              localStorage.setItem(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected)
              );
              setDynamicCookieForUser(
                LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
                JSON.stringify(doctorSelected),
                setCookie
              );
              setDoctorList(selectedDoctorArr);
            }
          } else {
            let selectedDoctorArr = [];
            doctorSelected = doctorSelected || [];
            selectedDoctorArr = res?.data?.all_related_doctors?.map(
              (doctor) => {
                return {
                  ...doctor,
                  selected: true,
                  selected_doctor: false,
                  doctor_first_name: doctor?.dr_first_name,
                  doctor_last_name:
                    doctor?.dr_middle_name + " " + doctor?.dr_last_name,
                  doctor_profile_picture_url: doctor?.profile_picture_url
                    ? [doctor?.profile_picture_url]
                    : [],
                  id: doctor?.doctor_id,
                  label: doctor?.dr_name,
                  value: doctor?.dr_first_name,
                  name: doctor?.dr_name,
                  initials: doctor?.dr_first_name?.charAt(0),
                  doctor_phone_no: doctor?.dr_phone_no,
                  doctor_name: doctor?.dr_name,
                };
              }
            );
            doctorSelected.push({
              clinic_id: clinicId,
              doctors: selectedDoctorArr,
            });
            // console.log(" ----> 6", doctorSelected);
            localStorage.setItem(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected)
            );
            setDynamicCookieForUser(
              LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
              JSON.stringify(doctorSelected),
              setCookie
            );
            setDoctorList(selectedDoctorArr);
          }
        } else {
          setDoctorList([]);
        }
      })
      .catch((error) => {
        setDoctorList([]);
        if (error?.response?.status === 403) {
          sessionExpiredError(() => {
            localStorage.clear();
            this.props.history.push("/doctor/login");
          });
        }
        C2CConsole.log(error);
      });
  };

  useEffect(() => {
    // console.log(
    //   " useffect ----> 7",
    //   localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
    // );
    if (
      localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS) &&
      localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS) !==
        "undefined" &&
      JSON.parse(
        localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
      )?.length > 0
    ) {
      let doctorSelected =
        localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS) &&
        localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS) !==
          "undefined"
          ? JSON.parse(
              localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
            )
          : [];
      if (
        doctorSelected?.length > 0 &&
        doctorSelected !== null &&
        (clinicId !== null || clinicId !== undefined)
      ) {
        var foundDoctorIndex = doctorSelected?.findIndex(
          (clinic) => clinic?.clinic_id === clinicId
        );
        if (foundDoctorIndex > -1) {
          let filterDoctors = [];
          filterDoctors = doctorList?.map((doctor) => {
            let data = doctorSelected[foundDoctorIndex]?.doctors?.some(
              (previous) =>
                doctor?.doctor_id === previous?.doctor_id &&
                previous.selected === true
            );
            if (data) {
              return {
                ...doctor,
                selected: true,
                selected_doctor: false,
                id: doctor?.doctor_id,
                label: doctor?.doctor_name,
                value: doctor?.doctor_first_name,
                name: doctor?.doctor_name,
                initials: doctor?.doctor_first_name?.charAt(0),
              };
            } else {
              return {
                ...doctor,
                selected: false,
                selected_doctor: false,
                id: doctor?.doctor_id,
                label: doctor?.doctor_name,
                value: doctor?.doctor_first_name,
                name: doctor?.doctor_name,
                initials: doctor?.doctor_first_name?.charAt(0),
              };
            }
          });

          setSelectedDoctor(filterDoctors);
        } else {
          doctorList?.length &&
            doctorList.map((data) => {
              data.selected = true;
            });

          setSelectedDoctor(doctorList);
        }
      } else {
        doctorList?.length &&
          doctorList.map((data) => {
            data.selected = true;
          });

        setSelectedDoctor(doctorList);
      }
    } else {
      doctorList?.length &&
        doctorList.map((data) => {
          data.selected = true;
        });
      setSelectedDoctor(doctorList);
    }
  }, [doctorList]);

  return (
    <>
      <DoctorContext.Provider
        value={{
          doctorList,
          setDoctorList,
          selectedDoctor,
          setSelectedDoctor,
          clinic_id,
          doctorRole,
          setDoctorRole,
          setClinicId,
          enableLeadsDashboard,
          setEnableLeadsDashboard,
        }}
      >
        {children}
      </DoctorContext.Provider>
    </>
  );
};

export default DoctorContext;
